// extracted by mini-css-extract-plugin
export default {"root":"slider-arrow-button_root__3hPQK","darkTheme":"slider-arrow-button_darkTheme__WTARn","icon":"slider-arrow-button_icon__DVQxV"};